/**
 * @desc 二字码查询国家信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.CountryResponseDto>;
export function request(secondWord: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/country/bySecondWord/${secondWord}`, {
      method: "GET",

      ...options,
    }),
  );
}
